import { ActionReducerMap } from '@ngrx/store';
import { PermSetStates } from '../states';

import * as fromPermSetReducers from './perm-set.reducers';

export const permSetReducers: ActionReducerMap<PermSetStates> = {
    permSet: fromPermSetReducers.permSetReducer
};